import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import LogsPage from './pages/LogsPage';
import DevicesPage from './pages/DevicesPage';
import LkUsersPage from './pages/LkUsersPage';
import RequestTypesPage from './pages/RequestTypesPage';
import AiTestPage from './pages/AiTestPage';
import SettingsPage from './pages/SettingsPage';
import './App.css';

// Контекст авторизации
export const AuthContext = React.createContext(null);

function App() {
  const [token, setToken] = useState(() => {
    return localStorage.getItem('admin_token') || null;
  });

  const login = (newToken) => {
    localStorage.setItem('admin_token', newToken);
    setToken(newToken);
  };

  const logout = () => {
    localStorage.removeItem('admin_token');
    setToken(null);
  };

  // Защищённый роут
  const ProtectedRoute = ({ children }) => {
    if (!token) {
      return <Navigate to="/login" replace />;
    }
    return children;
  };

  return (
    <AuthContext.Provider value={{ token, login, logout }}>
      <div className="app">
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          
          <Route path="/" element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }>
            <Route index element={<Navigate to="/logs" replace />} />
            <Route path="logs" element={<LogsPage />} />
            <Route path="devices" element={<DevicesPage />} />
            <Route path="lk-users" element={<LkUsersPage />} />
            <Route path="request-types" element={<RequestTypesPage />} />
            <Route path="ai-test" element={<AiTestPage />} />
            <Route path="settings" element={<SettingsPage />} />
          </Route>
          
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </AuthContext.Provider>
  );
}

export default App;